// import React, { useState, useEffect, useRef } from "react";
// import Slider from "react-slick";
// import { InverterDetail } from "../../../../../../api/Api";
// import "./MainSlider.css";
// import Solarpic from "../../../../../../assets/img/logos/solarlogin.jpg";

// const MainSlider = () => {
//     const [logData, setLogData] = useState([]);
//     const [error, setError] = useState(null); // State to store error
//     const [loading, setLoading] = useState(true); // State to store loading status

//     // Refs to hold carousel and page section elements
//     const sliderRef = useRef(null);
//     const pageRef = useRef(null);

//     // Credentials stored in state
//     const [credentials] = useState({
//         LOGIN_ID: localStorage.getItem("LoginID") || "",
//         LOC_CODE: localStorage.getItem("LCODE") || "",
//         PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//         WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     });

//     console.log("LCODE",credentials.LOC_CODE)
//     const fetchLogData = async () => {
//         setLoading(true); // Start loading

//         try {
//             const res = await InverterDetail(credentials);

//             if (res?.data && Array.isArray(res.data)) {
//                 console.log("Fetched Data:", res.data); // Debug fetched data
//                 setLogData(res.data);
//             } else {
//                 console.error("Data structure mismatch:", res);
//                 setLogData([]); // Set empty array on data mismatch
//             }
//         } catch (err) {
//             console.error("Error fetching data:", err);
//             setError("Failed to fetch data.");
//         } finally {
//             setLoading(false); // Stop loading after the fetch completes
//         }
//     };

//     useEffect(() => {
//         fetchLogData();

//         // Set interval to refresh data every minute (60,000 ms)
//         const intervalId = setInterval(() => {
//             fetchLogData();
//         }, 30000); // 1 minute = 60000ms

//         // Cleanup function to clear interval on component unmount
//         return () => clearInterval(intervalId);

//     }, [credentials.LOGIN_ID]); // Runs only once after mounting

//     useEffect(() => {
//         // Handle scrolling between sections
//         const handleScroll = (e) => {
//             const delta = e.deltaY;
//             const scrollableSections = pageRef.current.children;
//             const currentSection = document.documentElement.scrollTop || document.body.scrollTop;

//             if (delta > 0) {
//                 // Scrolling down, scroll to next section
//                 for (let i = 0; i < scrollableSections.length; i++) {
//                     if (scrollableSections[i].offsetTop > currentSection) {
//                         scrollableSections[i].scrollIntoView({ behavior: "smooth" });
//                         break;
//                     }
//                 }
//             } else {
//                 // Scrolling up, scroll to previous section
//                 for (let i = scrollableSections.length - 1; i >= 0; i--) {
//                     if (scrollableSections[i].offsetTop < currentSection) {
//                         scrollableSections[i].scrollIntoView({ behavior: "smooth" });
//                         break;
//                     }
//                 }
//             }
//         };

//         // Adding the scroll event listener
//         window.addEventListener("wheel", handleScroll, { passive: true });

//         // Cleanup the event listener on component unmount
//         return () => window.removeEventListener("wheel", handleScroll);
//     }, []);

//     // const settings = {
//     //     dots: true,
//     //     infinite: true,
//     //     speed: 500,
//     //     slidesToShow: 1, // Number of items to show at a time
//     //     slidesToScroll: 1, // Number of items to scroll at a time
//     //     autoplay: true,
//     //     autoplaySpeed: 2000,
//     //     responsive: [
//     //         {
//     //             breakpoint: 768, // Mobile view
//     //             settings: {
//     //                 slidesToShow: 1,
//     //                 slidesToScroll: 1,
//     //             },
//     //         },
//     //     ],
//     // };


//     const settings = {
//         dots: logData.length > 1, // Sirf jab multiple items ho tab dots show kare
//         infinite: logData.length > 1, // Infinite loop tabhi ho jab multiple items ho
//         speed: 500,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         autoplay: true, // Yahan autoplay ko forcefully enable rakhein
//         autoplaySpeed: 2000,
//         arrows: logData.length > 1, // Sirf multiple items ke liye arrows dikhaye
//         responsive: [
//             {
//                 breakpoint: 768,
//                 settings: {
//                     slidesToShow: 1,
//                     slidesToScroll: 1,
//                 },
//             },
//         ],
//     };
        
//     return (
//         <div className="container " ref={pageRef}>
//             <div className="section" style={{ }}>
//                 {loading && <p>Loading...</p>} {/* Show loading indicator */}
//                 {error && <p style={{ color: "red" }}>{error}</p>} {/* Show error message */}
//                 <Slider {...settings} ref={sliderRef}>
//                     {logData.map((item, index) => (
//                        <div key={index} className="card mx-1  shadow-sm rounded-sm">
                       
//                             <div className="card-body">

//                                 <div className="">
//                                    <h5 className="card-title " style={{marginBottom:"1rem"}}><strong>Name:</strong> <span style={{ color:"#00FFFF" }}>{item.NAME}</span></h5> 
//                                    <p><span style={{fontSize:"19px",color:"#00FFFF"}}>{item.KW}</span>&nbsp;<span style={{color:"red"}}>kW</span></p>
//                                    <p>Status: &nbsp;<span style={{color: item.STS === "Online" ? "green" : "red"}}>{item.STS}</span></p>
//                                    <p>Date: &nbsp;<span style={{color:"#00FFFF"}}>{item.E_DATE || "N/A"}</span></p>
//                                 </div>


//                                 <div className="textDiv d-flex flex-column">
//                                     {/* Row 1: Name on the left, dynamic values on the right */}
//                                     <div className="d-flex justify-content-between">
//                                         <div>
//                                             <p><strong>Make:</strong></p>
//                                         </div>

//                                         <div>
//                                             <p style={{color:"#00FFFF"}}>{item.MAKE}</p>
//                                         </div>
//                                     </div>
//                                     {item.AC_CAP && (
//                                         <div className="d-flex justify-content-between">
//                                             <div>
//                                                 <p><strong>AC Capacity:</strong></p>
//                                             </div>
//                                             <div>
//                                                 <p style={{color:"#00FFFF"}}>{item.AC_CAP}</p>
//                                             </div>
//                                         </div>
//                                     )}
//                                     <div className="d-flex justify-content-between">
//                                         <div>
//                                             <p><strong>{item.CAPACITY_PREFIX}</strong></p>
//                                         </div>
//                                         <div>
//                                             <p style={{color:"#00FFFF"}}>{item.KWP}</p>
//                                         </div>
//                                     </div>

//                                     {/* Row 2: Additional dynamic values */}
//                                     <div className="d-flex justify-content-between">
//                                         <div>
//                                             <p><strong>Life kWh:</strong></p>
//                                         </div>
//                                         <div>
//                                             <p style={{color:"#00FFFF"}}>{item.TOT_GEN}</p>
//                                         </div>
//                                     </div>

//                                     <div className="d-flex justify-content-between">
//                                         <div>
//                                             <p className="text-muted">Event:</p>
//                                         </div>
//                                         <div>
//                                             <p  style={{color:"#00FFFF"}}>{item.ALARM || "N/A"}</p>
//                                         </div>
//                                     </div>

//                                 </div>

//                             </div>
//                         </div>
//                     ))}
//                 </Slider>
//             </div>
//         </div>
//     );
// };

// export default MainSlider;


// 2.

import React, { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import carousel styles

import { InverterDetail } from "../../../../../../api/Api";
import "./MainSlider.css";

const MainSlider = () => {
  const [logData, setLogData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const [credentials] = useState({
    LOGIN_ID: localStorage.getItem("LoginID") || "",
    LOC_CODE: localStorage.getItem("LCODE") || "",
    PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
    WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
  });

  const fetchLogData = async () => {
    setLoading(true);
    try {
      const res = await InverterDetail(credentials);
      if (res?.data && Array.isArray(res.data)) {
        const uniqueData = res.data.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.NAME === item.NAME)
        );
        setLogData(uniqueData);
      } else {
        setLogData([]);
      }
    } catch (err) {
      setError("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogData();
    const intervalId = setInterval(fetchLogData, 30000);
    return () => clearInterval(intervalId);
  }, [credentials.LOGIN_ID]);

  return (
    <div className="container">
      {loading && <p>Loading...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
      <Carousel 
        autoPlay={true} 
        interval={2000} 
        infiniteLoop={true} 
        showArrows={true} 
        showIndicators={true} 
        showThumbs={false}
      >
        {logData.map((item, index) => (
          <div key={index} className="card mx-1  shadow-sm rounded-sm">
                       
          <div className="card-body">

              <div className="text-start">
                 <h5 className="card-title " style={{marginBottom:"1rem"}}><strong></strong> <span style={{ color:"#00FFFF" }}>{item.NAME}</span></h5> 
                 <p>Live:&nbsp;<span style={{fontSize:"19px",color:"#00FFFF"}}>{item.KW}</span>&nbsp;<span style={{color:"red"}}>kW</span> &nbsp;&nbsp; Today Yield:&nbsp;<span style={{fontSize:"19px",color:"#00FFFF"}}>{item.DAY_KWH}</span>&nbsp;<span style={{color:"red"}}>kWh</span></p>                 <p>Status: &nbsp;<span style={{color: item.STS === "Online" ? "#90ee90" : "red"}}>{item.STS}</span></p>
                 <p>Date: &nbsp;<span style={{color:"#00FFFF"}}>{item.E_DATE || "N/A"}</span></p>
              </div>


              <div className="textDiv d-flex flex-column">
                  {/* Row 1: Name on the left, dynamic values on the right */}
                  <div className="d-flex justify-content-between">
                      <div>
                          <p><strong>Make:</strong></p>
                      </div>

                      <div>
                          <p style={{color:"#00FFFF"}}>{item.MAKE}</p>
                      </div>
                  </div>
                  {item.AC_CAP && (
                      <div className="d-flex justify-content-between">
                          <div>
                              <p><strong>AC Capacity:</strong></p>
                          </div>
                          <div>
                              <p style={{color:"#00FFFF"}}>{item.AC_CAP}</p>
                          </div>
                      </div>
                  )}
                  <div className="d-flex justify-content-between">
                      <div>
                          <p><strong>{item.CAPACITY_PREFIX}</strong></p>
                      </div>
                      <div>
                          <p style={{color:"#00FFFF"}}>{item.KWP}</p>
                      </div>
                  </div>

                  {/* Row 2: Additional dynamic values */}
                  <div className="d-flex justify-content-between">
                      <div>
                          <p><strong>Life kWh:</strong></p>
                      </div>
                      <div>
                          <p style={{color:"#00FFFF"}}>{item.TOT_GEN}</p>
                      </div>
                  </div>

                  <div className="d-flex justify-content-between">
                      <div>
                          <p className="text-muted">Event:</p>
                      </div>
                      <div>
                          <p  style={{color:"#00FFFF"}}>{item.ALARM || "N/A"}</p>
                      </div>
                  </div>

              </div>

          </div>

      </div>
        ))}
      </Carousel>
    </div>
  );
};

export default MainSlider;





